import styled, { css } from 'styled-components/macro';
import { IconBoxProps, RootProps } from './field-message.types';
import { sizeConfig } from '../_core/field';

export const Root = styled.span<RootProps>`
  ${({ theme, $status }) => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.spacings.xxs};
    color: ${$status
      ? theme.semantic.text[$status]
      : theme.semantic.text.secondary};
  `}
`;

export const IconBox = styled.span<IconBoxProps>`
  ${({ theme, $size }) => css`
    display: flex;
    align-items: center;
    flex: none;
    height: ${sizeConfig(theme)[$size].lineHeight};

    svg {
      display: block;
      min-width: 16px;
      height: 16px;
    }
  `}
`;
